import React, { useEffect } from "react";
import styles from "./PostRadioButton.module.css";
import { useState, useMemo } from "react";

const PostRadioButton = React.memo(function ({
  postClick = () => {},
  notPostClick = () => {},
  disabled = false,
  defaultValue = true,
}) {
  const [state, setState] = useState({
    onOff: true,
  });
  const dynamicStyle = useMemo(() => {
    if (disabled) {
      return {
        backgroundColor: "#f2f2f2",
        color: "#999",
        borderColor: "#ccc",
        cursor: "not-allowed",
        opacity: "0.6",
      };
    } else {
      return {
        cursor: "pointer",
      };
    }
  }, [disabled]);
  const clickedPost = () => {
    setState((s) => ({ ...s, onOff: true }));
    postClick();
  };
  const clickedNotPost = () => {
    setState((s) => ({ ...s, onOff: false }));
    notPostClick();
  };

  useEffect(() => {
    setState((s) => ({ ...s, onOff: defaultValue }));
  }, []);

  return (
    <div className={styles.postButtonArea}>
      <div
        className={
          state.onOff
            ? `${styles.postButton} ${styles.onBackgound}`
            : styles.postButton
        }
        style={dynamicStyle}
        onClick={clickedPost}
      >
        <span
          className={
            state.onOff ? `${styles.post} ${styles.onLetter}` : styles.post
          }
          style={dynamicStyle}
        >
          게시하기
        </span>
      </div>
      <div
        className={
          !state.onOff
            ? `${styles.notPostButton} ${styles.onBackgound}`
            : styles.notPostButton
        }
        style={dynamicStyle}
        onClick={clickedNotPost}
      >
        <span
          className={
            !state.onOff
              ? `${styles.notPost} ${styles.onLetter}`
              : styles.notPost
          }
          style={dynamicStyle}
        >
          게시하지 않기
        </span>
      </div>
    </div>
  );
});

export default PostRadioButton;
